<template>
  <div>
    <div class="bd">
      <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
        <!-- src="https://www.thingjs.com/s/9a01df4d8d46552cdc77aa0f?params=105b0f77fd24654d4eebc434e9" -->


      <iframe
        class="iframe"
        id="iframe"
        frameborder="0"
        src="https://www.thingjs.com/s/fe3f46b1661dc856778c1573"
      ></iframe>
      <div
        v-if="loading"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="
          position: fixed;
          z-index: 999999;
          left: 0;
          top: 0;
          width: 100vw;
          height: 100vh;
        "
      ></div>
      <div v-if="!loading">
        <div class="head">
          <div v-if="type == 'index' && selectIndex == 0">
            <div class="showtime" @click="showTime(1)" v-if="statusTime == 0">
              开启预览
            </div>
            <div class="showtime" @click="showTime(0)" v-if="statusTime == 1">
              关闭预览
            </div>
          </div>
          <div class="title">
            <!-- 天之源三维智能信息管理系统 -->
          </div>
          <div class="nowtime">{{ nowTime }}</div>
        </div>
        <div v-if="selectIndex <= 4 && selectIndex >= 0">
          <div class="" v-if="selectIndex == 0">
            <IndexModel :screenHeight="screenHeight"></IndexModel>
          </div>
          <div class="main" v-if="selectIndex == 1">
            <IndexModelTwo :screenHeight="screenHeight"></IndexModelTwo>
          </div>
          <div class="main" v-if="selectIndex == 2">
            <IndexModelThree :screenHeight="screenHeight"></IndexModelThree>
          </div>
          <div class="main" v-if="selectIndex == 3">
            <IndexModelFour :screenHeight="screenHeight"></IndexModelFour>
          </div>
          <div class="main" v-if="selectIndex == 4">
            <IndexModelFive :screenHeight="screenHeight"></IndexModelFive>
          </div>
        </div>
        <div v-if="selectIndex >= 5 && selectIndex <= 11">
          <div class="main" v-if="selectIndex == 5">
            <ElectricWatchInfoLeft
              :screenHeight="screenHeight"
            ></ElectricWatchInfoLeft>
          </div>
          <div class="main" v-if="selectIndex == 6">
            <ElectricWatchInfoRight
              type="model1"
              :screenHeight="screenHeight"
            ></ElectricWatchInfoRight>
          </div>
          <div class="main" v-if="selectIndex == 7">
            <ElectricWatchInfoRightTwo
              type="model2"
              :screenHeight="screenHeight"
            ></ElectricWatchInfoRightTwo>
          </div>
          <div class="main" v-if="selectIndex == 8">
            <ElectricWatchInfoRightThree
              type="model3"
              :screenHeight="screenHeight"
            ></ElectricWatchInfoRightThree>
          </div>
          <div class="main" v-if="selectIndex == 9">
            <ElectricOneFloorOne
              :screenHeight="screenHeight"
            ></ElectricOneFloorOne>
          </div>
          <div class="main" v-if="selectIndex == 10">
            <ElectricOneFloorTwo
              :screenHeight="screenHeight"
            ></ElectricOneFloorTwo>
          </div>
          <div class="main" v-if="selectIndex == 11">
            <ElectricOneFloorThree
              :screenHeight="screenHeight"
            ></ElectricOneFloorThree>
          </div>
        </div>

        <div v-if="selectIndex >= 44 && selectIndex <= 47">
          <div class="main" v-if="selectIndex == 44">
            <ElectricTwoFloorWatchInfoRightThree
              type="model3"
              :screenHeight="screenHeight"
            ></ElectricTwoFloorWatchInfoRightThree>
          </div>

          <div class="main" v-if="selectIndex == 45">
            <ElectricTwoFloorOne
              :screenHeight="screenHeight"
            ></ElectricTwoFloorOne>
          </div>
          <div class="main" v-if="selectIndex == 46">
            <ElectricTwoFloorTwo
              :screenHeight="screenHeight"
            ></ElectricTwoFloorTwo>
          </div>
          <div class="main" v-if="selectIndex == 47">
            <ElectricTwoFloorThree
              :screenHeight="screenHeight"
            ></ElectricTwoFloorThree>
          </div>
        </div>
        <div
          v-if="(selectIndex >= 12 && selectIndex <= 13) || selectIndex == 48"
        >
          <div class="main" v-if="selectIndex == 12">
            <ElectricThreeFloorOne
              :screenHeight="screenHeight"
            ></ElectricThreeFloorOne>
          </div>
          <div class="main" v-else-if="selectIndex == 13">
            <ElectricThreeFloorTwo
              :screenHeight="screenHeight"
            ></ElectricThreeFloorTwo>
          </div>
          <div class="main" v-else-if="selectIndex == 48">
            <ElectricThreeFloorThree
              :screenHeight="screenHeight"
            ></ElectricThreeFloorThree>
          </div>
        </div>
        <div v-if="selectIndex >= 14 && selectIndex <= 16">
          <div class="main" v-if="selectIndex == 14">
            <CarWasteInventoryOne
              :screenHeight="screenHeight"
            ></CarWasteInventoryOne>
          </div>
          <div class="main" v-if="selectIndex == 15">
            <CarWasteInventoryTwo
              :screenHeight="screenHeight"
            ></CarWasteInventoryTwo>
          </div>
          <div class="main" v-if="selectIndex == 16">
            <CarWasteInventoryThree
              :screenHeight="screenHeight"
            ></CarWasteInventoryThree>
          </div>
        </div>
        <div v-if="selectIndex >= 17 && selectIndex <= 18">
          <div class="main" v-if="selectIndex == 17">
            <!-- 汽废预处理车间-生产线 -->
            <CarWastePrepareRoomOne
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomOne>
          </div>
          <div class="main" v-else-if="selectIndex == 18">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomTwo
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomTwo>
          </div>
          <div class="main" v-else-if="selectIndex == 17.5">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomVideo
              :clickVideo="clickVideo"
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomVideo>
          </div>
        </div>
        <div v-if="selectIndex >= 19 && selectIndex <= 23">
          <div class="main" v-if="selectIndex == 19">
            <!-- 汽废拆解房间1-生产线 -->
            <CarWasteRoomOneFloorOne
              :screenHeight="screenHeight"
            ></CarWasteRoomOneFloorOne>
          </div>
          <div class="main" v-else-if="selectIndex == 20">
            <!-- 汽废拆解房间1-库存 -->
            <CarWasteRoomOneFloorTwo
              :screenHeight="screenHeight"
            ></CarWasteRoomOneFloorTwo>
          </div>
          <div class="main" v-else-if="selectIndex == 21">
            <!-- 汽废拆解房间1-监控 -->
            <CarWasteRoomOneFloorThree
              :screenHeight="screenHeight"
            ></CarWasteRoomOneFloorThree>
          </div>
          <div class="main" v-else-if="selectIndex == 21.5">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomVideo
              :clickVideo="clickVideo"
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomVideo>
          </div>
          <div class="main" v-else-if="selectIndex == 22">
            <!-- 汽废拆解房间1-入库 -->
            <CarWasteRoomOneFloorFour
              :screenHeight="screenHeight"
            ></CarWasteRoomOneFloorFour>
          </div>
          <div class="main" v-else-if="selectIndex == 23">
            <!-- 汽废拆解房间1-出库 -->
            <CarWasteRoomOneFloorFive
              :screenHeight="screenHeight"
            ></CarWasteRoomOneFloorFive>
          </div>
        </div>
        <div v-if="selectIndex >= 24 && selectIndex <= 28">
          <div class="main" v-if="selectIndex == 24">
            <!-- 汽废拆解房间2-生产线 -->
            <CarWasteRoomTwoFloorOne
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoFloorOne>
          </div>
          <div class="main" v-else-if="selectIndex == 25">
            <!-- 汽废拆解房间2-库存 -->
            <CarWasteRoomTwoFloorTwo
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoFloorTwo>
          </div>
          <div class="main" v-else-if="selectIndex == 26">
            <!-- 汽废拆解房间2-入库 -->
            <CarWasteRoomTwoFloorThree
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoFloorThree>
          </div>
          <div class="main" v-else-if="selectIndex == 27">
            <!-- 汽废拆解房间2-出库 -->
            <CarWasteRoomTwoFloorFour
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoFloorFour>
          </div>
          <div class="main" v-else-if="selectIndex == 28">
            <!-- 汽废拆解房间2-监控 -->
            <CarWasteRoomTwoFloorFive
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoFloorFive>
          </div>
          <div class="main" v-else-if="selectIndex == 27.5">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomVideo
              :clickVideo="clickVideo"
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomVideo>
          </div>
        </div>
        <div v-if="selectIndex >= 29 && selectIndex <= 30">
          <div class="main" v-if="selectIndex == 29">
            <!-- 医废输液瓶车间-总览 -->
            <MedicalWasteRoomOneAllInfoOne
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneAllInfoOne>
          </div>
          <div class="main" v-else-if="selectIndex == 30">
            <!-- 医废输液瓶车间-监控 -->
            <MedicalWasteRoomOneAllInfoWatchInfo
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneAllInfoWatchInfo>
          </div>
        </div>
        <div v-if="selectIndex >= 31 && selectIndex <= 33">
          <div class="main" v-if="selectIndex == 31">
            <!-- 医废输液瓶车间-库存总览 -->
            <MedicalWasteRoomOneInventoryOne
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneInventoryOne>
          </div>
          <div class="main" v-else-if="selectIndex == 32">
            <!-- 医废输液瓶车间-库存入库 -->
            <MedicalWasteRoomOneInventoryWarehousing
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneInventoryWarehousing>
          </div>
          <div class="main" v-else-if="selectIndex == 33">
            <!-- 医废输液瓶车间-库存监控 -->
            <MedicalWasteRoomOneInventoryWatchInfo
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneInventoryWatchInfo>
          </div>
        </div>
        <div v-if="selectIndex >= 34 && selectIndex <= 37">
          <div class="main" v-if="selectIndex == 34">
            <!-- 医废输液瓶车间-库存总览 -->
            <MedicalWasteRoomOneProductOne
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneProductOne>
          </div>
          <div class="main" v-else-if="selectIndex == 35">
            <!-- 医废输液瓶车间-库存入库 -->
            <MedicalWasteRoomOneProductEnter
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneProductEnter>
          </div>
          <div class="main" v-else-if="selectIndex == 36">
            <!-- 医废输液瓶车间-库存出库 -->
            <MedicalWasteRoomOneProductOut
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneProductOut>
          </div>
          <div class="main" v-else-if="selectIndex == 37">
            <!-- 医废输液瓶车间-库存监控 -->
            <MedicalWasteRoomOneProductWatchInfo
              :screenHeight="screenHeight"
            ></MedicalWasteRoomOneProductWatchInfo>
          </div>
          <div class="main" v-else-if="selectIndex == 36.5">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomVideo
              :clickVideo="clickVideo"
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomVideo>
          </div>
        </div>
        <div v-if="selectIndex >= 38 && selectIndex <= 40">
          <div class="main" v-if="selectIndex == 38">
            <!-- 医废高温处理车间（room1）-总览 -->
            <MedicalWasteRoomTwoAllInfoOne
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoAllInfoOne>
          </div>
          <div class="main" v-else-if="selectIndex == 39">
            <!-- 医废高温处理车间（room1）-出库 -->
            <MedicalWasteRoomTwoAllInfoOut
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoAllInfoOut>
          </div>
          <div class="main" v-else-if="selectIndex == 40">
            <!-- 医废高温处理车间（room1）-监控 -->
            <MedicalWasteRoomTwoAllInfoWatchInfo
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoAllInfoWatchInfo>
          </div>
          <div class="main" v-else-if="selectIndex == 38.5">
            <!-- 汽废预处理车间-监控 -->
            <CarWastePrepareRoomVideo
              :clickVideo="clickVideo"
              :screenHeight="screenHeight"
            ></CarWastePrepareRoomVideo>
          </div>
        </div>
        <div v-if="selectIndex >= 41 && selectIndex <= 43">
          <div class="main" v-if="selectIndex == 41">
            <!-- 医废高温处理车间（room2）-总览 -->
            <MedicalWasteRoomTwoInventoryOne
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoInventoryOne>
          </div>
          <div class="main" v-else-if="selectIndex == 42">
            <!-- 医废高温处理车间（room2）-入库 -->
            <MedicalWasteRoomTwoInventoryWarehousing
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoInventoryWarehousing>
          </div>
          <div class="main" v-else-if="selectIndex == 43">
            <!-- 医废高温处理车间（room2）-监控 -->
            <MedicalWasteRoomTwoInventoryWatchInfo
              :screenHeight="screenHeight"
            ></MedicalWasteRoomTwoInventoryWatchInfo>
          </div>
        </div>
        <div v-if="selectIndex >= 49 && selectIndex <= 51">
          <div class="main" v-if="selectIndex == 49">
            <!-- 汽废预处理车间详情 -->
            <CarWastePrepareDetail
              :screenHeight="screenHeight"
            ></CarWastePrepareDetail>
          </div>
          <div class="main" v-else-if="selectIndex == 50">
            <!-- 汽废拆解处理车间（room1）-详情 -->
            <CarWasteRoomOneDetail
              :screenHeight="screenHeight"
            ></CarWasteRoomOneDetail>
          </div>
          <div class="main" v-else-if="selectIndex == 51">
            <!-- 汽废拆解处理车间（room2）-详情 -->
            <CarWasteRoomTwoDetail
              :screenHeight="screenHeight"
            ></CarWasteRoomTwoDetail>
          </div>
        </div>
        <div v-if="selectIndex >= 53 && selectIndex <= 55">
          <div class="main" v-if="selectIndex == 53">
            <!-- 汽废预处理车间详情 -->
            <AllInventoryOne :screenHeight="screenHeight"></AllInventoryOne>
          </div>
          <div class="main" v-else-if="selectIndex == 54">
            <!-- 汽废拆解处理车间（room1）-详情 -->
            <AllInventoryTwo :screenHeight="screenHeight"></AllInventoryTwo>
          </div>
          <div class="main" v-else-if="selectIndex == 55">
            <!-- 汽废拆解处理车间（room2）-详情 -->
            <AllInventoryThree :screenHeight="screenHeight"></AllInventoryThree>
          </div>
        </div>
        <div>
          <!-- 首页 -->
          <FooterModel
            v-if="type == 'index'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterModel>

          <!-- 电一楼监控 -->
          <FooterElectricWatchInfoOneFloor
            v-if="type == 'FooterElectricWatchInfoOneFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterElectricWatchInfoOneFloor>

          <!-- 电一楼操作 -->
          <FooterElectricOneFloor
            v-if="type == 'FooterElectricOneFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterElectricOneFloor>

          <!-- 电二楼监控 -->
          <FooterElectricWatchInfoTwoFloor
            v-if="type == 'FooterElectricWatchInfoTwoFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterElectricWatchInfoTwoFloor>

          <!-- 电二楼操作 -->
          <FooterElectricTwoFloor
            v-if="type == 'FooterElectricTwoFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterElectricTwoFloor>

          <!-- 电三楼操作 -->
          <FooterElectricThreeFloor
            v-if="type == 'FooterElectricThreeFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterElectricThreeFloor>

          <!-- 汽库存操作 -->
          <FooterCarWasteInventory
            v-if="type == 'FooterCarWasteInventory'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterCarWasteInventory>

          <!-- 汽废-预处理车间底部 -->
          <FooterCarWastePrepareRoom
            v-if="type == 'FooterCarWastePrepareRoom'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterCarWastePrepareRoom>

          <!-- 汽废-拆解房间1底部 -->
          <FooterCarWasteOneFloor
            v-if="type == 'FooterCarWasteOneFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterCarWasteOneFloor>

          <!-- 汽废-拆解房间2底部 -->
          <FooterCarWasteTwoFloor
            v-if="type == 'FooterCarWasteTwoFloor'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterCarWasteTwoFloor>

          <!-- 医废-高温处理-总览底部 -->
          <FooterMedicalWasteRoomTwoAllInfo
            v-if="type == 'FooterMedicalWasteRoomTwoAllInfo'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterMedicalWasteRoomTwoAllInfo>

          <!-- 医废-高温处理-库存底部 -->
          <FooterMedicalWasteRoomTwoInventory
            v-if="type == 'FooterMedicalWasteRoomTwoInventory'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterMedicalWasteRoomTwoInventory>

          <!-- 医废-输液瓶-总览底部 -->
          <FooterMedicalWasteRoomOneAllInfo
            v-if="type == 'FooterMedicalWasteRoomOneAllInfo'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterMedicalWasteRoomOneAllInfo>

          <!-- 医废-输液瓶-库存底部 -->
          <FooterMedicalWasteRoomOneInventory
            v-if="type == 'FooterMedicalWasteRoomOneInventory'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterMedicalWasteRoomOneInventory>

          <!-- 医废-输液瓶-产出物底部 -->
          <FooterMedicalWasteRoomOneProduct
            v-if="type == 'FooterMedicalWasteRoomOneProduct'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterMedicalWasteRoomOneProduct>

          <!-- 医废-输液瓶-产出物底部 -->
          <FooterAllInfo
            v-if="type == 'FooterAllInfo'"
            @selectMenu="selectMenu"
            :index="selectIndex"
          ></FooterAllInfo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
// 首页模块
import IndexModel from "@/components/indexModel/indexModel"; //首页公司简介
import IndexModelTwo from "@/components/indexModel/indexModelTwo"; //首页汽废
import IndexModelThree from "@/components/indexModel/indexModelThree"; //首页电废
import IndexModelFour from "@/components/indexModel/indexModelFour"; //首页医废
import IndexModelFive from "@/components/indexModel/indexModelFive"; //首页双碳

// 电废模块
import ElectricWatchInfoLeft from "@/components/ElectricWaste/oneFloor/modelWatchInfoLeft"; //电废一楼监控-左侧页面
import ElectricWatchInfoRight from "@/components/ElectricWaste/oneFloor/modelWatchInfoRight"; //电废一楼监控-右侧页面
import ElectricWatchInfoRightTwo from "@/components/ElectricWaste/oneFloor/modelWatchInfoRightTwo"; //电废一楼监控-右侧页面
import ElectricWatchInfoRightThree from "@/components/ElectricWaste/oneFloor/modelWatchInfoRightThree"; //电废一楼监控-右侧页面
import ElectricOneFloorOne from "@/components/ElectricWaste/oneFloor/modelOne"; //电废一楼-库存
import ElectricOneFloorTwo from "@/components/ElectricWaste/oneFloor/modelTwo"; //电废一楼产出物-入库
import ElectricOneFloorThree from "@/components/ElectricWaste/oneFloor/modelThree"; //电废一楼产出物-出库

import ElectricTwoFloorWatchInfoLeft from "@/components/ElectricWaste/twoFloor/modelWatchInfoLeft"; //电废二楼监控-左侧页面
import ElectricTwoFloorWatchInfoRight from "@/components/ElectricWaste/twoFloor/modelWatchInfoRight"; //电废二楼监控-右侧页面
import ElectricTwoFloorWatchInfoRightTwo from "@/components/ElectricWaste/twoFloor/modelWatchInfoRightTwo"; //电废二楼监控-右侧页面
import ElectricTwoFloorWatchInfoRightThree from "@/components/ElectricWaste/twoFloor/modelWatchInfoRightThree"; //电废二楼监控-右侧页面
import ElectricTwoFloorOne from "@/components/ElectricWaste/twoFloor/modelOne"; //电废二楼-库存
import ElectricTwoFloorTwo from "@/components/ElectricWaste/twoFloor/modelTwo"; //电废二楼产出物-入库
import ElectricTwoFloorThree from "@/components/ElectricWaste/twoFloor/modelThree"; //电废二楼产出物-出库

import ElectricThreeFloorOne from "@/components/ElectricWaste/threeFloor/modelOne"; //电废三楼-库存
import ElectricThreeFloorTwo from "@/components/ElectricWaste/threeFloor/modelTwo"; //电废三楼-入库
import ElectricThreeFloorThree from "@/components/ElectricWaste/threeFloor/modelWatch"; //电废三楼-模型展示

// 总平
import AllInventoryOne from "@/components/AllInventory/modelOne"; //总平-库存
import AllInventoryTwo from "@/components/AllInventory/modelTwo"; //总平-入库
import AllInventoryThree from "@/components/AllInventory/modelThree"; //总平-出库
// 汽废模块-库存
import CarWasteInventoryOne from "@/components/CarWaste/inventory/modelOne"; //汽废-库存
import CarWasteInventoryTwo from "@/components/CarWaste/inventory/modelTwo"; //汽废-入库
import CarWasteInventoryThree from "@/components/CarWaste/inventory/modelThree"; //汽废-出库

// 汽废模块-预处理车间
import CarWastePrepareRoomOne from "@/components/CarWaste/prepareRoom/modelOne"; //汽废预处理车间-生产线
import CarWastePrepareRoomTwo from "@/components/CarWaste/prepareRoom/modelTwo"; //汽废预处理车间-监控
import CarWastePrepareRoomThree from "@/components/CarWaste/prepareRoom/modelInfo"; //汽废预处理车间-模型展示
import CarWastePrepareRoomVideo from "@/components/CarWaste/prepareRoom/modelVideo"; //汽废预处理车间-监控（单）

// 汽废模块-拆卸1车间
import CarWasteRoomOneFloorOne from "@/components/CarWaste/room1/modelOne"; //汽废拆解房间1-生产线
import CarWasteRoomOneFloorTwo from "@/components/CarWaste/room1/modelTwo"; //汽废拆解房间1-库存
import CarWasteRoomOneFloorThree from "@/components/CarWaste/room1/modelThree"; //汽废拆解房间1-监控
import CarWasteRoomOneFloorFour from "@/components/CarWaste/room1/modelFour"; //汽废拆解房间1-入库
import CarWasteRoomOneFloorFive from "@/components/CarWaste/room1/modelFive"; //汽废拆解房间1-出库
import CarWasteRoomOneFloorInfo from "@/components/CarWaste/room1/modelInfo"; //汽废拆解房间1-模型

// 汽废模块-拆卸2车间
import CarWasteRoomTwoFloorOne from "@/components/CarWaste/room2/modelOne"; //汽废拆解房间2-生产线
import CarWasteRoomTwoFloorTwo from "@/components/CarWaste/room2/modelTwo"; //汽废拆解房间2-库存
import CarWasteRoomTwoFloorThree from "@/components/CarWaste/room2/modelThree"; //汽废拆解房间2-入库
import CarWasteRoomTwoFloorFour from "@/components/CarWaste/room2/modelFour"; //汽废拆解房间2-出库
import CarWasteRoomTwoFloorFive from "@/components/CarWaste/room2/modelFive"; //汽废拆解房间2-监控

//汽废模块-详情
import CarWastePrepareDetail from "@/components/CarWaste/detail/preprocessingDetail"; //汽废预处理详情
import CarWasteRoomOneDetail from "@/components/CarWaste/detail/disassembleDetail1"; //汽废拆解房间1详情
import CarWasteRoomTwoDetail from "@/components/CarWaste/detail/disassembleDetail2"; //汽废拆解车间2详情

// 医废模块-输液瓶车间（room1）模型总览页面
import MedicalWasteRoomOneAllInfoInfo from "@/components/MedicalWaste/room1/allInfo/modelInfo"; //医废输液瓶车间-模型+视频信息
import MedicalWasteRoomOneAllInfoOne from "@/components/MedicalWaste/room1/allInfo/modelOne"; //医废输液瓶车间-总览
import MedicalWasteRoomOneAllInfoWatchInfo from "@/components/MedicalWaste/room1/allInfo/modelWatchInfo"; //医废输液瓶车间-监控

// 医废模块-输液瓶车间（room1）库存页面
import MedicalWasteRoomOneInventoryOne from "@/components/MedicalWaste/room1/inventory/modelOne"; //医废输液瓶车间-总览
import MedicalWasteRoomOneInventoryWarehousing from "@/components/MedicalWaste/room1/inventory/modelWarehousing"; //医废输液瓶车间-入库
import MedicalWasteRoomOneInventoryWatchInfo from "@/components/MedicalWaste/room1/inventory/modelWatchInfo"; //医废输液瓶车间-监控

// 医废模块-输液瓶车间（room1）库存页面
import MedicalWasteRoomOneProductOne from "@/components/MedicalWaste/room1/product/modelOne"; //医废输液瓶车间-总览
import MedicalWasteRoomOneProductEnter from "@/components/MedicalWaste/room1/product/modelEnter"; //医废输液瓶车间-入库
import MedicalWasteRoomOneProductOut from "@/components/MedicalWaste/room1/product/modelOut"; //医废输液瓶车间-出库
import MedicalWasteRoomOneProductWatchInfo from "@/components/MedicalWaste/room1/product/modelWatchInfo"; //医废输液瓶车间-监控

// 医废模块-高温处理车间（room2）模型总览页面
import MedicalWasteRoomTwoAllInfoInfo from "@/components/MedicalWaste/room2/allInfo/modelInfo"; //医废高温处理车间-模型+视频信息
import MedicalWasteRoomTwoAllInfoOne from "@/components/MedicalWaste/room2/allInfo/modelOne"; //医废高温处理车间-总览
import MedicalWasteRoomTwoAllInfoOut from "@/components/MedicalWaste/room2/allInfo/modelOut"; //医废高温处理车间-出库
import MedicalWasteRoomTwoAllInfoWatchInfo from "@/components/MedicalWaste/room2/allInfo/modelWatchInfo"; //医废高温处理车间-监控

// 医废模块-高温处理车间（room2）库存页面
import MedicalWasteRoomTwoInventoryOne from "@/components/MedicalWaste/room2/inventory/modelOne"; //医废高温处理车间-总览
import MedicalWasteRoomTwoInventoryWarehousing from "@/components/MedicalWaste/room2/inventory/modelWarehousing"; //医废高温处理车间-入库
import MedicalWasteRoomTwoInventoryWatchInfo from "@/components/MedicalWaste/room2/inventory/modelWatchInfo"; //医废高温处理车间-监控

// 底部组件
import FooterModel from "@/components/indexModel/footerIndex"; //首页底部
import FooterElectricWatchInfoOneFloor from "@/components/ElectricWaste/oneFloor/footerIndex"; //电废-一楼监控底部
import FooterElectricOneFloor from "@/components/ElectricWaste/oneFloor/footerModelOne"; //电废-一楼信息底部

import FooterElectricWatchInfoTwoFloor from "@/components/ElectricWaste/twoFloor/footerIndex"; //电废-一楼监控底部
import FooterElectricTwoFloor from "@/components/ElectricWaste/twoFloor/footerModelOne"; //电废-一楼信息底部

import FooterElectricThreeFloor from "@/components/ElectricWaste/threeFloor/footerModelOne"; //电废-三楼底部
// 汽废底部
import FooterCarWasteInventory from "@/components/CarWaste/inventory/footerModelOne"; //汽废-库存底部
import FooterCarWastePrepareRoom from "@/components/CarWaste/prepareRoom/footerModelOne"; //汽废-预处理车间底部
import FooterCarWasteOneFloor from "@/components/CarWaste/room1/footerModelOne"; //汽废-拆解房间1底部
import FooterCarWasteTwoFloor from "@/components/CarWaste/room2/footerModelOne"; //汽废-拆解房间2底部
// 医废底部
import FooterMedicalWasteRoomTwoAllInfo from "@/components/MedicalWaste/room2/allInfo/footerModelOne"; //医废-高温处理-总览底部
import FooterMedicalWasteRoomTwoInventory from "@/components/MedicalWaste/room2/inventory/footerModelOne"; //医废-高温处理-库存底部

import FooterMedicalWasteRoomOneAllInfo from "@/components/MedicalWaste/room1/allInfo/footerModelOne"; //医废-输液瓶-总览底部
import FooterMedicalWasteRoomOneInventory from "@/components/MedicalWaste/room1/inventory/footerModelOne"; //医废-输液瓶-库存底部
import FooterMedicalWasteRoomOneProduct from "@/components/MedicalWaste/room1/product/footerModelOne"; //医废-输液瓶-产出物底部
import { log } from "video.js";

import FooterAllInfo from "@/components/AllInventory/footerModelOne"; //总平库存区域

export default {
  components: {
    AllInventoryOne,
    AllInventoryTwo,
    AllInventoryThree,
    FooterAllInfo,

    ElectricWatchInfoLeft,
    ElectricWatchInfoRight,
    ElectricWatchInfoRightTwo,
    ElectricWatchInfoRightThree,
    ElectricOneFloorOne,
    ElectricOneFloorTwo,
    ElectricOneFloorThree,

    ElectricTwoFloorWatchInfoLeft,
    ElectricTwoFloorWatchInfoRight,
    ElectricTwoFloorWatchInfoRightTwo,
    ElectricTwoFloorWatchInfoRightThree,
    ElectricTwoFloorOne,
    ElectricTwoFloorTwo,
    ElectricTwoFloorThree,

    ElectricThreeFloorOne,
    ElectricThreeFloorTwo,
    ElectricThreeFloorThree,
    CarWasteInventoryOne,
    CarWasteInventoryTwo,
    CarWasteInventoryThree,
    CarWastePrepareRoomOne,
    CarWastePrepareRoomTwo,
    CarWastePrepareRoomThree,
    CarWastePrepareRoomVideo,
    CarWasteRoomOneFloorOne,
    CarWasteRoomOneFloorTwo,
    CarWasteRoomOneFloorThree,
    CarWasteRoomOneFloorFour,
    CarWasteRoomOneFloorFive,
    CarWasteRoomOneFloorInfo,
    CarWasteRoomTwoFloorOne,
    CarWasteRoomTwoFloorTwo,
    CarWasteRoomTwoFloorThree,
    CarWasteRoomTwoFloorFour,
    CarWasteRoomTwoFloorFive,
    CarWastePrepareDetail,
    CarWasteRoomOneDetail,
    CarWasteRoomTwoDetail,
    MedicalWasteRoomOneAllInfoInfo,
    MedicalWasteRoomOneAllInfoOne,
    MedicalWasteRoomOneAllInfoWatchInfo,
    MedicalWasteRoomOneInventoryOne,
    MedicalWasteRoomOneInventoryWarehousing,
    MedicalWasteRoomOneInventoryWatchInfo,
    MedicalWasteRoomOneProductOne,
    MedicalWasteRoomOneProductEnter,
    MedicalWasteRoomOneProductOut,
    MedicalWasteRoomOneProductWatchInfo,
    MedicalWasteRoomTwoAllInfoInfo,
    MedicalWasteRoomTwoAllInfoOne,
    MedicalWasteRoomTwoAllInfoOut,
    MedicalWasteRoomTwoAllInfoWatchInfo,
    MedicalWasteRoomTwoInventoryOne,
    MedicalWasteRoomTwoInventoryWarehousing,
    MedicalWasteRoomTwoInventoryWatchInfo,
    IndexModelThree,
    IndexModelFour,
    IndexModelTwo,
    IndexModel,
    IndexModelFive,
    FooterModel,
    FooterElectricWatchInfoOneFloor,
    FooterElectricOneFloor,
    FooterElectricWatchInfoTwoFloor,
    FooterElectricTwoFloor,

    FooterElectricThreeFloor,
    FooterCarWasteInventory,
    FooterCarWastePrepareRoom,
    FooterCarWasteOneFloor,
    FooterCarWasteTwoFloor,
    FooterMedicalWasteRoomTwoAllInfo,
    FooterMedicalWasteRoomTwoInventory,
    FooterMedicalWasteRoomOneAllInfo,
    FooterMedicalWasteRoomOneInventory,
    FooterMedicalWasteRoomOneProduct,
  },
  data() {
    return {
      loading: true,
      selectIndex: -1,
      nowTime: "",
      type: "",
      clickVideo: "",
      screenHeight: "",
      scroolrightheight: "",
      scroolleftheight: "",
      statusTime: 0,
      showTimeName: "开启预览",
    };
  },
  mounted() {
    let self = this;
    if (window.innerWidth < 1660) {
      // this.screenHeight = window.innerHeight * 0.75 + "px";
      this.screenHeight = window.innerHeight * 0.79 + "px";
    } else {
      this.screenHeight = window.innerHeight * 0.77 + "px";
    }
    var mySwiper = new Swiper("#swiperIndex", {
      //配置分页器内容
      loop: true, // 循环模式选项
      pagination: {
        el: ".swiper-pagination", //换页器与哪个标签关联
        clickable: true, //分页器是否可以点击
      },
    });
    this.getNowTime();
    window.addEventListener(
      "message",
      function (e) {
        // console.log(e.data, "外来因素");
        // 显示页面
        if (e.data.funcName == "isShowPage") {
          self.selectMenu(0);
          self.type = "index";

          self.isShowPage(e.data.param);
        }
        // 双击建筑/楼层处罚
        if (e.data.funcName == "enterBuild") {
          console.log(e.data.param.name);
          self.type = "";
          self.selectIndex = -1;
          if (e.data.param.oneBuild) {
            // 电废楼FooterElectricWatchInfoOneFloor
            if (e.data.param.name.includes("F1")) {
              self.selectIndex = 5;
              self.type = "FooterElectricOneFloor";
              //console.log("1楼");
            } else if (e.data.param.name.includes("F2")) {
              self.selectIndex = 44;
              self.type = "FooterElectricTwoFloor";
              //console.log("2楼");
            } else if (e.data.param.name.includes("F3")) {
              self.selectIndex = 48;
              self.type = "FooterElectricThreeFloor";
              //console.log("3楼");
            } else {
              self.selectIndex = 48;
              self.type = "FooterElectricThreeFloor";
            }
          } else {
            self.enterBuild(e.data.param.name);
          }
        }

        // 推出楼层回到首页园区
        if (e.data.funcName == "backIndex") {
          self.type = "index";
          self.selectMenu(0);
        }
        // 医废单喽双底部
        if (e.data.funcName == "openModelFooter") {
          // console.log(e.data.param.id);
          self.selectIndex = -1;
          if (e.data.param.id == "输液瓶、袋存放区") {
            self.type = "FooterMedicalWasteRoomOneInventory";
            self.selectIndex = 31;
          }
          if (e.data.param.id == "塑料颗粒存放区") {
            self.type = "FooterMedicalWasteRoomOneProduct";
            self.selectIndex = 34;
          }

          if (e.data.param.id == "3号楼01房间") {
            self.type = "FooterMedicalWasteRoomTwoAllInfo";
            self.selectIndex = 38;
          }
          if (e.data.param.id == "3号楼02房间") {
            self.type = "FooterMedicalWasteRoomTwoInventory";
            self.selectIndex = 41;
          }
          console.log(self.selectIndex);
        }
        // 点击显示模型
        if (e.data.funcName == "openModel") {
          self.selectIndex = -1;
        }
        // 点击显示数据
        if (e.data.funcName == "openDataInfo") {
          // self.selectIndex = -1;
          self.enterDetail(e.data.param);
          // console.log(e.data.param, self.selectIndex);
        }
        // 点击显示监控
        if (e.data.funcName == "openVideo") {
          //console.log(self.type, "self.type");
          // 汽-预处理
          if (self.type == "FooterCarWastePrepareRoom") {
            self.selectIndex = 17.1;
            setTimeout(() => {
              self.selectIndex = 17.5;
              self.clickVideo = e.data.param.id;
            }, 300);
          }
          //汽-拆解1
          if (self.type == "FooterCarWasteOneFloor") {
            self.selectIndex = 21.1;
            setTimeout(() => {
              self.selectIndex = 21.5;
              self.clickVideo = e.data.param.id;
            }, 300);
          }
          //汽-拆解2
          if (self.type == "FooterCarWasteTwoFloor") {
            self.selectIndex = 27.1;
            //console.log(e.data.param.id);
            setTimeout(() => {
              self.selectIndex = 27.5;
              self.clickVideo = e.data.param.id;
            }, 300);
          }
          //医-高温
          if (self.type == "FooterMedicalWasteRoomOneAllInfo") {
            self.selectIndex = 38.1;
            //console.log(e.data.param.id);
            setTimeout(() => {
              self.selectIndex = 38.5;
              self.clickVideo = e.data.param.id;
            }, 300);
          }
          //医-高温
          if (self.type == "FooterMedicalWasteRoomTwoAllInfo") {
            self.selectIndex = 36.1;
            //console.log(e.data.param.id);
            setTimeout(() => {
              self.selectIndex = 36.5;
              self.clickVideo = e.data.param.id;
            }, 300);
          }
        }
      },
      false
    );
  },
  methods: {
    //汽废详情
    enterDetail(params) {
      // let { floorName } = params;
      // let { idName } = params;

      console.log(params.id);
      if (
        params.floorName == "天之源工业园区7号楼" ||
        params.floorName == "天之源工业园区-7号楼"
      ) {
        if (params.id == "金属废料存放区") {
          this.selectIndex = 49;
        }
        if (params.id.includes("轮胎、轮毂存放区")) {
          this.selectIndex = 50;
        }
      } else if (
        params.floorName == "天之源工业园区4号楼" ||
        params.floorName == "天之源工业园区-4号楼"
      ) {
        this.selectIndex = 51;
      }
    },

    enterBuild(name) {
      let self = this;
      console.log(name, "双击触发");

      if (
        name.includes("天之源工业园区2号楼") ||
        name.includes("天之源工业园区-2号楼")
      ) {
        // 汽废-拆解2
        self.type = "FooterMedicalWasteRoomOneAllInfo";
        self.selectIndex = 29;
      }
      if (
        name.includes("天之源工业园区4号楼") ||
        name.includes("天之源工业园区-4号楼")
      ) {
        // 汽废-拆解2
        self.type = "FooterCarWasteTwoFloor";
        self.selectIndex = 24;
      }
      if (
        name.includes("天之源工业园区5号楼") ||
        name.includes("天之源工业园区-5号楼")
      ) {
        // 汽废-预处理
        self.type = "FooterCarWastePrepareRoom";
        self.selectIndex = 17;
      }
      if (
        name.includes("天之源工业园区7号楼") ||
        name.includes("天之源工业园区-7号楼")
      ) {
        // 汽废楼-拆卸1
        self.type = "FooterCarWasteOneFloor";
        self.selectIndex = 19;
      }
      if (
        name.includes("天之源工业园区12号楼") ||
        name.includes("天之源工业园区-12号楼")
      ) {
        // 汽废楼-拆卸1
        self.type = "FooterCarWasteInventory";
        self.selectIndex = 14;
      }
      if (name.includes("隐藏")) {
        // 汽废楼-拆卸1
        self.type = "";
        self.selectIndex = -1;
      }
    },
    selectMenu(index) {
      console.log(index);
      // 0-4首页按钮，
      // 5-8电废1楼监控，9-11电废1楼操作按钮，12-13电废3楼操作按钮（1号楼的操作）
      // 14-16汽废库存按钮，17-18预处理车间按钮（5号楼操作），19-23拆解车间1操作，24-28拆解车间2操作
      // 29-30医废输液瓶处理车间总览操作，31-33库存区操作，34-37产出物操作，
      // 38-40高温处理车间总览操作，41-43库存区操作，
      if (index == this.selectIndex) {
        this.selectIndex = -1;
        return;
      }
      this.selectIndex = index;
      this.$forceUpdate();
      //console.log("selectMenu", index);
      //0-4首页按钮
      if (index >= 0 && index <= 4) {
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "indexInfoFly",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //5-8电废1楼监控
      if (index >= 5 && index <= 8) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");

        //console.log("5-8电废1楼监控");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //9-11电废1楼操作按钮
      if (index >= 9 && index <= 11) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");

        //console.log("9-11电废1楼操作按钮");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //12-13电废3楼操作按钮
      if (index >= 12 && index <= 13) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("12-13电废3楼操作按钮");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //14-16汽废库存按钮
      if (index >= 14 && index <= 16) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");

        //console.log("14-16汽废库存按钮");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //17-18预处理车间按钮
      if (index >= 17 && index <= 18) {
        //console.log("预处理车间");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //19-23拆解车间1操作
      if (index >= 19 && index <= 23) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("19-23拆解车间1操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //24-28拆解车间2操作
      if (index >= 24 && index <= 28) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("24-28拆解车间2操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //医废输液瓶处理车间总览操作
      if (index >= 29 && index <= 30) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("医废输液瓶处理车间总览操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //31-33库存区操作
      if (index >= 31 && index <= 33) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("31-33库存区操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //34-37产出物操作
      if (index >= 34 && index <= 37) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("34-37产出物操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //38-40高温处理车间总览操作
      if (index >= 38 && index <= 40) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");
        //console.log("38-40高温处理车间总览操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
      //41-43库存区操作
      if (index >= 41 && index <= 43) {
        // var a = document.getElementById("iframe");
        // var msg = {
        //   funcName: "indexInfoFly",
        //   param: index,
        // };
        // a.contentWindow.postMessage(msg, "*");

        //console.log("41-43库存区操作");
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "prepareRoomChange",
          param: index,
        };
        a.contentWindow.postMessage(msg, "*");
      }
    },
    isShowPage(info) {
      //console.log(info);
      if (info.isShow) {
        this.loading = false;
      }
    },
    getNowTime() {
      let speed = 1000;
      let that = this;
      let theNowTime = function () {
        that.nowTime = that.timeNumber();
      };
      setInterval(theNowTime, speed);
    },
    timeNumber() {
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        this.twoDigits(today.getMonth() + 1) +
        "-" +
        this.twoDigits(today.getDate());
      let time =
        this.twoDigits(today.getHours()) +
        ":" +
        this.twoDigits(today.getMinutes()) +
        ":" +
        this.twoDigits(today.getSeconds());
      return date + "  " + time;
    },
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
    showTime(status) {
      console.log(status);
      this.statusTime = status;
      this.$forceUpdate();
      if (status == 0) {
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "cleartime",
          param: status,
        };
        a.contentWindow.postMessage(msg, "*");
      } else {
        var a = document.getElementById("iframe");
        var msg = {
          funcName: "showTime",
          param: status,
        };
        a.contentWindow.postMessage(msg, "*");
      }
    },
  },
};
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
  width: 0px;
}
#swipercom {
  width: 100%;
}
#swiperIndex.swiper-container {
  width: 100%;
  height: auto;
}
#swiperIndex.swiper-container .swiper-slide img {
  width: 100%;
}
.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.head {
  width: 100%;
  height: 100px;
  background: url("~@/assets/top3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: flex-start;
  // margin-bottom: 30px;
  position: relative;
}
.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  // right: 30px;
  right: calc(50% - 560px);
  top: 30px;
}
.main .left,
.main .right {
  width: 21.5vw;
  height: 75vh;
  background: rgba(17, 47, 107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
}
.main .right {
  float: right;
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
}
::v-deep .main .left .left-content .type-title,
::v-deep .main .middle .middle-content .type-title,
::v-deep .main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 0px rgb(115, 95, 250) solid;
  // padding-left: 15px;
  padding-left: 45px;
  font-size: 19px;
  padding-bottom: 8px;
  background: url("~@/assets/titleBg.png") no-repeat;
  background-position-y: 5px;
  font-weight:bold;

  box-sizing: border-box;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main .left .left-content .video-content {
  width: 100%;
}

.main .left .left-content .video-content video {
  width: 100%;
}

.main .left .left-content .company-content {
  line-height: 40px;
  font-size: 18px;
  height: 51vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 100%;
}
.right-echarts-1 {
  width: 100%;
  height: 21.5vw;
}
::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
.showtime {
  font-size: 15px;
  color: #fff;
  position: absolute;
  top: 25px;
  // left: 16px;
  left: 12%;
  border: 1px #fff solid;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
